<template>
	<div class="opts_wrap" v-loading="loading">
		<div class="order_records" v-if="after_sales_info">
			<p>协商记录</p>
			<div class="records_wrap">
				<div class="record_con c">
					<p class="txt">发起了退款申请</p>
					<div class="txt_wrap">
						<el-descriptions labelClassName="la_style" contentClassName="con_style" :colon="false">
							<el-descriptions-item label="操作时间">{{after_sales_info.apply_time}}</el-descriptions-item>
							<el-descriptions-item label="操作人">买家</el-descriptions-item>
							<el-descriptions-item label="售后类型">{{after_sales_info.text_part.aftersale_type_text}}</el-descriptions-item>
							<el-descriptions-item label="货物状态">{{after_sales_info.text_part.logistics_text}}</el-descriptions-item>
							<el-descriptions-item label="退款原因">{{after_sales_info.text_part.reason_text}}</el-descriptions-item>
							<el-descriptions-item label="退款金额">￥{{after_sales_info.refund_amount}}</el-descriptions-item>
							<el-descriptions-item label="退货物流公司" v-if="after_sales_info.return_logistics_company_name">{{after_sales_info.return_logistics_company_name}}</el-descriptions-item>
							<el-descriptions-item label="退货物流单号" v-if="after_sales_info.return_logistics_code">{{after_sales_info.return_logistics_code}}</el-descriptions-item>
							<el-descriptions-item label="退货地址" v-if="after_sales_info.return_address">{{after_sales_info.return_address}}</el-descriptions-item>
						</el-descriptions>
					</div>
				</div>
				<div class="record_con b">
					<p class="txt">{{after_sales_info.text_part.aftersale_status_text}}</p>
					<div class="txt_wrap">
						<el-descriptions labelClassName="la_style" contentClassName="con_style" :column="3" :colon="false">
							<el-descriptions-item label="操作人">供应商</el-descriptions-item>
							<el-descriptions-item label="拒绝原因" v-if="after_sales_info.aftersale_status==27||after_sales_info.aftersale_status==29">{{after_sales_info.text_part.reason_text}}</el-descriptions-item>
							<el-descriptions-item label="换货发货快递" v-if="after_sales_info.exchange_logistics_company_name">{{after_sales_info.exchange_logistics_company_name}}</el-descriptions-item>
							<el-descriptions-item label="换货发货单号" v-if="after_sales_info.exchange_logistics_code">{{after_sales_info.exchange_logistics_code}}</el-descriptions-item>
							<el-descriptions-item label="更新时间">{{after_sales_info.update_time}}</el-descriptions-item>
						</el-descriptions>
					</div>
				</div>
				<el-divider v-if="after_sales_info.aftersale_type!=3"></el-divider>
				<div class="record_con b" v-if="after_sales_info.aftersale_type!=3">
					<p class="txt">采购费用</p>
					<div class="txt_wrap">
						<el-descriptions labelClassName="la_style" contentClassName="con_style" :column="3" :colon="false">
							<el-descriptions-item label="退款金额">{{info.total_cost_price}}</el-descriptions-item>
							<el-descriptions-item label="退款状态">{{after_sales_info.supplier_pass==0?'待退款':after_sales_info.supplier_pass==1?'同意退款':'拒绝退款'}}</el-descriptions-item>
							<el-descriptions-item label="操作时间" v-if="after_sales_info.supplier_pass>0">{{after_sales_info.supplier_check_time}}</el-descriptions-item>
							<el-descriptions-item label="拒绝原因" v-if="after_sales_info.supplier_pass==2">{{after_sales_info.supplier_refuse_content}}</el-descriptions-item>
							<el-descriptions-item label="凭证图片" v-if="after_sales_info.supplier_pass==2">
								<el-image
								    style="width: 100px; height: 100px;object-fit: contain;"
								    :src="after_sales_info.supplier_refuse_url"
								    :preview-src-list="[after_sales_info.supplier_refuse_url]">
								  </el-image>
							</el-descriptions-item>
						</el-descriptions>
					</div>
				</div>
				<el-divider></el-divider>
				<el-form style="margin-top: 30px;" ref="after_sales_form" :model="form" :rules="rules" label-width="80px" v-if="operate_type_list.length>0">
				  <el-form-item prop="type" label="售后操作"  v-if="operate_type_list.length>0">
				    <el-radio-group v-model="form.type" size="small" @change="bindTypeSelect">
				    	<el-radio :label="op.val" border v-for="(op,index) in operate_type_list" :key="index">{{op.text}}</el-radio>
				    </el-radio-group>
				  </el-form-item>
				  <el-form-item prop="reject_reason_code" label="拒绝原因" v-if="need_reject_reason_code">
				    <el-select size="small" v-model="form.reject_reason_code" placeholder="请选择">
							<el-option
								v-for="item in reject_reason_list"
								:key="item.reject_reason_code"
								:label="item.reason"
								:value="item.reject_reason_code">
							</el-option>
						</el-select>
				  </el-form-item>
				  <el-form-item prop="evidence_content" label="凭证描述" v-if="need_evidence">
				    <el-input type="textarea" v-model="form.evidence_content"></el-input>
				  </el-form-item>
					<el-form-item prop="evidence_url" label="上传凭证" v-if="need_evidence">
					  <el-upload
					  	class="avatar-uploader"
					  :http-request="uploadEvidence"
					  	:show-file-list="false"
					  	:on-success="handleAvatarSuccess">
							<div class="avatar" v-if="form.evidence_url" >
								<img class="img" :src="form.evidence_url"/>
								<i class="el-icon-close btn-del" @click.stop="form.evidence_url = ''"></i>
							</div>
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					  </el-upload>
					</el-form-item>
				  <el-form-item>
				  </el-form-item>
				</el-form>
			</div>
		</div>
		<div class="btn_wrap">
			<p class="btn" v-if="operate_type_list.length>0" @click="onSubmit">提交</p>
			<p class="btn" @click="cancel()">关闭</p>
		</div>
	</div>
</template>

<script>
import { mapActions,mapState,mapMutations } from "vuex";
import { createDirectUploadRequest } from "@/assets/js/utils/ossDirectUpload";
export default {
	name: "orderAddress",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		},
		info: {
			type: Object,
			default: function(){
				return {}
			}
		},
	},
	data() {
		return {
			after_sales_info:'',
			loading: false,
			reject_reason_list:[],
			operate_type_list:[],
			need_reject_reason_code:false,
			need_evidence:false,
			form:{
				order_id:'',
				aftersale_id: '',
				type:'',
				reject_reason_code:'',
				evidence_content:'',
				evidence_url:''
			},rules: {
			type: [
				{ required: true, message: '请选择售后操作', trigger: 'blur' },
				// { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
			],
			reject_reason_code: [
				{ required: true, message: '请选择拒绝原因', trigger: 'blur' },
			],
			reject_reason_code: [
				{ required: true, message: '请选择拒绝原因', trigger: 'blur' },
			],
			evidence_content: [
				{ required: true, message: '请输入凭证描述', trigger: 'blur' },
			],
		}
		};
	},
	created(){
	},
	mounted() {
		this.after_sales_info = this.info.order_after_sales
		this.init()
	},

	computed:{
		...mapState({

		}),
	},
	watch:{
		show(val) {
			if(val){
				this.init()
			}
		}
	},

	methods: {
		...mapActions({
			getOrderServerGetOperateInfo:"ucenter/getOrderServerGetOperateInfo",
			opOrderServerOpAfterSale:"ucenter/opOrderServerOpAfterSale"
		}),
		init(){
			// this.loading = true
			// this.need_reject_reason_code = false
			// this.need_evidence = false
			// console.log(this.after_sales_info)
			// this.form = {
			// 	order_id: this.after_sales_info.order_id,
			// 	aftersale_id: this.after_sales_info.aftersale_id,
			// 	type:'',
			// 	reject_reason_code:'',
			// 	evidence_content:'',
			// 	evidence_url:''
			// }

			this.after_sales_info = this.info.order_after_sales
			var param = {order_id:this.form.order_id,aftersale_id:this.form.aftersale_id}
			console.log(param)
			// this.getOrderServerGetOperateInfo({data:param,success:(res)=>{
			// 	console.log(res)
			// 	if(res.code===200){
			// 		this.reject_reason_list = res.data.reject_reason_list
			// 		this.operate_type_list = res.data.operate_type_list
			// 	} else {
			// 		this.$message({message: res.msg,type: 'error',});
			// 	}
			// 	this.loading = false
			// }})
		},
		bindTypeSelect(value){
			console.log(value)
			var type = this.operate_type_list.find(item => item.val == value)
			this.need_reject_reason_code = type.other.includes("reject_reason_code")
			this.need_evidence = type.other.includes("evidence")
		},
		onSubmit(){
			console.log(this.form)
			let that = this
			if(that.loading) return
			that.$refs['after_sales_form'].validate((valid) => {
					if (valid) {
						that.loading = true
						that.opOrderServerOpAfterSale({data:that.form,success:(res)=>{
							console.log(res)
							if(res.code == 200){
								that.$message({message: res.msg,type: 'success',});
								that.complete()
								that.cancel()
							}else{
								that.loading = false
								that.$message({message: res.msg,type: 'error',});
							}
						}})
					} else {
						that.$message({message: '缺少必填参数',type: 'error',});
						return false;
					}
				});
		},
		handleAvatarSuccess(res, file) {
			if(res.code == 200){
				this.form.evidence_url = res.data.address
			}else{
				this.$message({message: res.msg,type: 'error',});
			}
		},
		uploadEvidence(options) {
			createDirectUploadRequest(options, { purpose: 'merchant_image' });
		},
		cancel(){
			this.$emit('close', {})
		},
		complete(){
			this.$emit('complete',{})
		}
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{margin-top: 20px;display: flex;align-items: center;}
	.opts_line .txt{width: 100%;font-size: 16px;display: flex;}
	.opts_line .txt .label{min-width: 80px;display: inline-block;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}


	.order_records{margin-top: 15px;width: 100%;height: auto;box-sizing: border-box;padding: 0 40px 30px;background: #fff;line-height: 1;}
	.records_wrap{margin-top: 25px;}
	.records_wrap .record_con{padding-left: 42px;position: relative;}
	.record_con::before{width: 32px;height: 32px;border-radius: 50%;display: flex;justify-content: center;align-items: center;position: absolute;top: 0;left: 0;z-index: 2;font-size: 12px;font-weight: bold}
	.record_con.c{padding-bottom: 13px;}
	.record_con.c::before{content: '买家';background: #ffecee;color: var(--red);}
	.record_con.b::before{content: '商家';background: #f0ffee;color: #0e9f1f;}
	.record_con.c::after{content: '';width: 2px;height: 68%;background: #eee;position: absolute;left: 15px;top: 40px;}
	.record_con .txt{font-size: 14px;line-height: 32px;}
	.record_con .txt_wrap{margin-top: 12px;width: 100%;font-size: 12px;}
	.record_con .txt_wrap .red{color: var(--red);}

	/deep/.el-input--suffix.is-focus .el-input__inner{border-color: var(--red) !important;}
	/*red border color*/
	/deep/.el-textarea__inner:focus,.el-textarea__inner:hover, .el-input__inner:focus ,.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus ,.el-select .el-input__inner:hover,.el-radio__input.is-checked .el-radio__inner ,.el-radio__inner:hover,.el-radio.is-bordered.is-checked{border-color: var(--red) !important;}

	/*red color*/
	/deep/.el-select-dropdown__item.selected ,.el-radio__input.is-checked+.el-radio__label{color: var(--red);}

	/*red background color*/
	.el-radio__input.is-checked .el-radio__inner{background-color: var(--red);}
	.el-radio{margin-right:10px;}
	.el-descriptions-item__container{align-item:center;}



</style>
<style>
	.el-select-dropdown__item.selected{color: var(--red) !important;}
	.el-select .el-input__inner:focus{border-color: var(--red) !important;}
	.el-select .el-input.is-focus .el-input__inner{border-color: var(--red) !important;}
	.el-radio__input.is-checked+.el-radio__label{color: var(--red);}
	.el-radio__input.is-checked .el-radio__inner{border-color:soid var(--red);background:var(--red);border:1px solid var(--red);}

	.el-descriptions{font-size:12px;}
	.la_style{color: #999;width: 80px !important;}
</style>

<style>
	.el-select-dropdown__item.selected{color: var(--red) !important;}
	.el-select .el-input__inner:focus{border-color: var(--red) !important;}
	.el-select .el-input.is-focus .el-input__inner{border-color: var(--red) !important;}
	.el-radio__input.is-checked+.el-radio__label{color: var(--red);}
	.el-radio__input.is-checked .el-radio__inner{border-color:soid var(--red);background:var(--red);border:1px solid var(--red);}

	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9 !important;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }

	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    width: 110px;
	    height: 110px;
	    line-height: 110px;
	    text-align: center;
	  }
	  .avatar {
	    width: 110px;
	    height: 110px;
	    display: block;
			position: relative;
	  }
		.avatar .img{
			width: 100%;
			height: 100%;
		}
		.avatar .btn-del{
			position: absolute;
			right: 1px;
			top: 1px;
			font-size: 20px;
			color: var(--red);
		}

		.el-descriptions{font-size:12px;}
		.la_style{color: #999;width: 80px !important;}
</style>
